import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GdkLogoutService {
  private _configSubject: BehaviorSubject<any>;

  constructor() {
    this._configSubject = new BehaviorSubject<any>({ok: false, url: '/'});
  }

  logoutUpdate(v) {
    this._configSubject.next(v);
  }

  getData(): any {
    return this._configSubject.asObservable();
  }
}
